import styled from "styled-components";
import { theme } from "styles/theme";

export const ConfigPage = styled.div`
  color: ${theme.colors.textPrimary};

  .p-card {
    margin-bottom: 1.5rem;
    background: transparent !important;
    color: ${theme.colors.textPrimary};
    border: none !important;
    box-shadow: none !important;
  }

  .p-card .p-card-body {
    padding: 0;
  }

  .p-card .p-card-title {
    color: ${theme.colors.textPrimary};
    padding: 0 0 0.625rem;
    margin: 0 0 0.75rem;
    border-bottom: 1px solid ${theme.colors.border};
    font-size: 0.95rem;
  }

  .p-card .p-card-content,
  .p-card .p-card-body {
    color: ${theme.colors.textPrimary};
  }

  label {
    display: block;
    margin-bottom: 0.4rem;
    color: ${theme.colors.textPrimary};
    font-weight: ${theme.fontWeights.medium};
  }

  small {
    display: block;
    margin-top: 0.35rem;
    color: ${theme.colors.textSecondary};
  }

  p {
    color: ${theme.colors.textSecondary};
    margin: 0;
  }
`;

export const ConfigFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const ConfigGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem 1.5rem;
  width: 100%;

  @media (max-width: ${theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;

export const ConfigField = styled.div<{ $width?: string }>`
  width: 100%;
  ${(p) => (p.$width ? `max-width: ${p.$width};` : "")}

  .p-dropdown {
    width: 100%;
  }
`;

export const ConfigActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  padding-top: 0.25rem;

  .p-button {
    width: auto;
  }
`;

export const RegionFieldRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  max-width: 18rem;

  .p-dropdown,
  .p-inputnumber {
    flex: 1;
    min-width: 0;
  }

  .p-inputnumber,
  .p-inputnumber input {
    width: 100%;
  }

  .p-button {
    flex-shrink: 0;
    width: auto;
  }
`;

export const InfoText = styled.div`
  padding: 0.5rem 0.75rem;
  background-color: ${theme.colors.bgLight};
  border-radius: ${theme.borderRadius.small};
  border: none;
  color: ${theme.colors.textPrimary};
  font-size: 0.95rem;
  min-height: 2.5rem;
  display: flex;
  align-items: center;
`;

export const PoolShapeContainer = styled.div`
  margin-top: 0.5rem;
`;

export const PoolShapeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 0.5rem;

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const PoolShapeCard = styled.div<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: ${theme.colors.bgLight};
  border-radius: ${theme.borderRadius.small};
  border: 1px solid
    ${(props) =>
      props.$selected ? theme.colors.textSecondary : theme.colors.border};
  color: ${theme.colors.textPrimary};
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  &:hover {
    background-color: ${theme.colors.bgLighter};
    border-color: ${theme.colors.textSecondary};
  }
`;

export const PoolShapeImage = styled.img`
  width: 100%;
  max-width: 150px;
  height: auto;
  margin-bottom: 0.5rem;
`;

export const PoolShapeName = styled.span`
  font-weight: ${theme.fontWeights.medium};
  margin-top: 0.5rem;
  color: inherit;
`;

export const ConnectivitySection = styled.div`
  margin-top: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;

  .p-button {
    width: auto;
  }
`;
